import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Button, Dialog, Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import * as CommonConstants from "utilities/CommonConstants";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { EventType } from "pages/statuses/EventType";
import { DateUtil } from "utilities/DateUtil";
import { Paths } from "Paths";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cancelButton: {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        closeButton: {
            position: `absolute`,
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
        message: {
            textAlign: `center`,
            marginTop: theme.spacing(5),
        },
    })
);

interface Props {
    // 開くダイアログ選択
    isOpen: boolean;
    // キャンセル
    onClickCancel: VoidFunction;
    // リンク押下
    onClickLink: VoidFunction;
    // 予約情報
    booking: EventType;
}

/**
 * 研究室注意事項表示ダイアログコンポーネント
 * 研究室の予約が重複している場合に呼び出されるコンポーネント
 */
export const LaboratoryCautionsDialog: React.FC<Props> = (props) => {
    const { isOpen, onClickCancel, booking, onClickLink } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    const body = (
        <div>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClickCancel}>
                <CloseIcon />
            </IconButton>
            <div className={classes.message}>
                {booking.subscriberLaboratoryName}は既に予約が入っています。
                <br />
                {DateUtil.parseViewDate(booking.start, booking.end)}
                <br />
                ※二重予約は出来ません。
                <br />
                日時を変更する場合はキャンセルをしてから再度予約してください
            </div>
            <Grid container justify="flex-end">
                <Button color="primary" onClick={onClickCancel} className={classes.cancelButton}>
                    キャンセル
                </Button>
            </Grid>
        </div>
    );

    return (
        <div>
            <Dialog
                fullWidth={true}
                fullScreen={!isPcSize}
                open={isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {body}
            </Dialog>
        </div>
    );
};
